import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const FORM_INPUT_VALIDATION_MESSAGES: Record<string, string> = {
  required: 'form.validation.errors.required',
  email: 'form.validation.errors.email',
  minlength: 'form.validation.errors.minlength',
  maxlength: 'form.validation.errors.maxlength',
  pattern: 'form.validation.errors.pattern',
};

export const noWhitespaceValidator: ValidatorFn = (control: AbstractControl<string>): ValidationErrors | null =>
  (control.value ?? '').trim().length > 0 ? null : { required: true };
